import { fetchFirebaseFunction } from '@/lib/firebaseFunctions';
import { findArtifactFile } from '@shared/types';
import type { ArtifactFile, ParametricArtifact } from '@shared/types';

export async function downloadConversationAssetBlob(
  conversationId: string,
  assetPath: string,
): Promise<Blob> {
  const response = await fetchFirebaseFunction('downloadAsset', {
    method: 'POST',
    body: JSON.stringify({
      conversationId,
      assetPath,
    }),
  });

  if (!response.ok) {
    throw new Error(`Asset download failed: ${response.status}`);
  }

  return response.blob();
}

/** Returns the STL preview file for the in-app 3D viewer (Three.js STLLoader). */
export function getPreviewMeshFile(
  artifact: ParametricArtifact | undefined,
): ArtifactFile | undefined {
  return findArtifactFile(artifact?.files, 'preview', 'stl');
}

/** Returns the 3MF manufacturing-handoff file when present. May be undefined
 *  on builds where lib3mf isn't linked into the WASM (B5 outcome B). */
export function getManufacturingMeshFile(
  artifact: ParametricArtifact | undefined,
): ArtifactFile | undefined {
  return findArtifactFile(artifact?.files, 'manufacturing', '3mf');
}

/** Returns the SCAD source file for download. */
export function getSourceFile(
  artifact: ParametricArtifact | undefined,
): ArtifactFile | undefined {
  return findArtifactFile(artifact?.files, 'source', 'scad');
}
